import { useState } from 'react';

import { ModalBase } from '../../../components/modals/ModalBase';
import { readProposedMessage } from '../tela9-adapter';

import type React from 'react';

const TEXT_FLOOR = 1;
const TEXT_CEIL = 4000;

export interface OverrideApprovalModalProps {
  open: boolean;
  /** contextPayload do override (Tipo 1) — pré-preenche o editedText com a message proposta. */
  payload: unknown;
  isPending: boolean;
  failed: boolean;
  outcome: string | null;
  onClose: () => void;
  onConfirm: (args: { editedText: string; approvalNote?: string }) => void;
}

export function OverrideApprovalModal({
  open,
  payload,
  isPending,
  failed,
  outcome,
  onClose,
  onConfirm,
}: OverrideApprovalModalProps): React.JSX.Element | null {
  const [editedText, setEditedText] = useState(() => readProposedMessage(payload));
  const [note, setNote] = useState('');
  if (!open) return null;

  const trimmedLen = editedText.trim().length;
  const canSubmit = trimmedLen >= TEXT_FLOOR && trimmedLen <= TEXT_CEIL && !isPending;

  return (
    <ModalBase
      open={open}
      onClose={onClose}
      title="Editar e enviar mensagem"
      width={560}
      footer={
        <div style={{ display: 'flex', gap: 8, marginLeft: 'auto' }}>
          <button className="btn-ghost-mini" type="button" onClick={onClose} disabled={isPending}>
            Cancelar
          </button>
          <button
            className="btn-ghost-mini btn-ghost-mini--primary"
            type="button"
            disabled={!canSubmit}
            onClick={() =>
              onConfirm({
                editedText: editedText.trim(),
                ...(note.trim() === '' ? {} : { approvalNote: note.trim() }),
              })
            }
          >
            {isPending ? 'Enviando…' : 'Aprovar e enviar'}
          </button>
        </div>
      }
    >
      <div className="modal-form">
        <label className="modal-form__field">
          <span className="modal-form__label">Mensagem a enviar (obrigatória)</span>
          <textarea
            className="modal-form__textarea"
            value={editedText}
            onChange={(e) => setEditedText(e.target.value)}
            rows={4}
            placeholder="Texto final que será enviado ao cliente…"
          />
          <span className="modal-form__hint">{trimmedLen}/{TEXT_CEIL}</span>
        </label>
        <label className="modal-form__field">
          <span className="modal-form__label">Nota de aprovação (opcional)</span>
          <textarea
            className="modal-form__textarea"
            value={note}
            onChange={(e) => setNote(e.target.value)}
            rows={2}
          />
        </label>
        {failed && (
          <div className="banner banner--danger" role="alert">
            <div className="banner__body">
              <span className="banner__title">Não foi possível aprovar e enviar a mensagem.</span>
            </div>
          </div>
        )}
        {outcome !== null && (
          <div className="modal-form__callout" role="status">
            {outcome}
          </div>
        )}
      </div>
    </ModalBase>
  );
}
